// styles/StyledComponents.js
import styled from 'styled-components';

export const Section = styled.section`
  padding: 5rem 2rem;
  background: #000000 !important;
  position: relative;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: 3rem 1rem;
  }
`;

export const Container = styled.div`
  max-width: 1350px;
  margin: 0 auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  align-items: center;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.gap || '1rem'};
  flex-direction: ${props => props.direction || 'row'};
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  background: ${props => props.variant === 'outline' ? 'transparent' : props.theme.gradients.primary};
  color: ${props => props.variant === 'outline' ? props.theme.colors.primary : 'white'};
  border: 2px solid ${props => props.theme.colors.primary};
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => props.variant === 'outline' ? props.theme.colors.primary : props.theme.colors.accent};
    border-color: ${props => props.variant === 'outline' ? props.theme.colors.primary : props.theme.colors.accent};
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }
`;

export const Card = styled.div`
  background: #1a202c;
  padding: 2rem;
  border-radius: 1rem;
  border: 1px solid #2d3748;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
  color: #e2e8f0;
  
  &:hover {
    transform: translateY(-5px);
    border-color: #4a5568;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.7);
  }

  h3 {
    color: #ffffff;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #ffffff;
  background: ${props => props.theme.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;